/* eslint-disable import/prefer-default-export */
import type { User } from '@src/redux/reducers/auth'
import { UserSource } from '@src/endpoints/services/commonHdr.service'

export enum Permissions {
  CanChangePasswords = 'canChangePasswords'
}

export const getCognitoPermissions = () => [Permissions.CanChangePasswords]

export const getPermissions = (user: User) => {
  const { userSource } = (user || {}) as User
  switch (userSource) {
    case UserSource.COGNITO: {
      return getCognitoPermissions()
    }
    case UserSource.IDN_IDP:
    case UserSource.SOURCE_UNKNOWN:
    default: {
      return []
    }
  }
}
